import { Injectable, Inject } from '@angular/core';
import { Router } from '@angular/router';
import { Http } from "@angular/http";
import { HttpService } from "../../../_services/http.service";

@Injectable()
export class AsideNavService extends HttpService {

    httpService: HttpService;

    constructor(private http: Http, private router: Router,
        @Inject(HttpService) _httpService: HttpService) {
        super(http, router);
        this.httpService = _httpService;
    }


    getFeedbackPendingCount() {
        var url = "master/feedback/pendingcount";
        return this.httpService.httpGet(url);
    }

    getMenu(json) {
        var url = "menu/getMenu";
        return this.httpService.httpPost(url, json);
    }
    chkEnvironment() {
        var url = "dashboard/chkEnvironment";
        return this.httpService.httpGet(url);
    }
}



// WEBPACK FOOTER //
// ./src/app/theme/layouts/aside-nav/aside-nav.service.ts